import { Card1, Card2, Card3 } from "ui/SVG/target-cards";

export interface TargetData {
  id: number;
  title: string;
  text: string;
  Card: (props?: React.SVGProps<SVGSVGElement>) => JSX.Element
}

const data: TargetData[][] = [
  [
    {
      id: 0,
      title: 'Be the one-stop-shop for all things GameFi',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Accumsan consequat a fringilla quis justo, sit dignissim.',
      Card: Card1
    },
    {
      id: 1,
      title: 'Support the gaming ecosystem and build it',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Accumsan consequat a fringilla quis justo, sit dignissim.',
      Card: Card2
    },
  ],
  [
    {
      id: 2,
      title: 'Build a robust Metaverse for players and streamers ',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Accumsan consequat a fringilla quis justo, sit dignissim.',
      Card: Card3
    }
  ]
];

export default data;
